import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger, SheetClose } from './ui/sheet';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { label: 'Features', id: 'features' },
    { label: 'Reports', id: 'reports' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'glass-effect shadow-card' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_responsive-effortrak/artifacts/56zqorlp_logo-png.png"
              alt="EffTrak Logo"
              className="h-10 w-auto logo-animate"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-muted-foreground hover:text-foreground transition-colors duration-200 font-medium"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <Button 
              variant="ghost" 
              onClick={() => scrollToSection('contact')}
              className="text-muted-foreground hover:text-foreground"
            >
              Get Demo
            </Button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-primary hover:shadow-glow transition-all duration-300"
            >
              Start Free Trial
            </Button>
          </div>

          {/* Mobile Menu */}
          <div className="lg:hidden">
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="sm" className="p-2">
                  <Menu className="h-5 w-5" />
                  <span className="sr-only">Open menu</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-80">
                <div className="flex flex-col space-y-6 mt-8">
                  {/* Mobile Logo */}
                  <div className="flex items-center space-x-3">
                    <img
                      src="https://customer-assets.emergentagent.com/job_responsive-effortrak/artifacts/56zqorlp_logo-png.png"
                      alt="EffTrak Logo"
                      className="h-8 w-auto"
                    />
                  </div>
                  
                  {/* Mobile Navigation */}
                  <nav className="flex flex-col space-y-4">
                    {navItems.map((item) => (
                      <SheetClose asChild key={item.id}>
                        <button
                          onClick={() => scrollToSection(item.id)}
                          className="text-left text-lg text-muted-foreground hover:text-foreground transition-colors duration-200 py-2"
                        >
                          {item.label}
                        </button>
                      </SheetClose>
                    ))}
                  </nav>
                  
                  {/* Mobile CTA */}
                  <div className="flex flex-col space-y-3 pt-4">
                    <SheetClose asChild>
                      <Button 
                        variant="outline" 
                        onClick={() => scrollToSection('contact')}
                        className="w-full"
                      >
                        Get Demo
                      </Button>
                    </SheetClose>
                    <SheetClose asChild>
                      <Button 
                        onClick={() => scrollToSection('contact')}
                        className="w-full bg-gradient-primary hover:shadow-glow transition-all duration-300"
                      >
                        Start Free Trial
                      </Button>
                    </SheetClose>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;